import {h, Fragment} from "preact"
import { useAppStateSelector, pick, useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { response } = useAppStateSelector(state => pick(state, "response"))
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="ns-autocomplete ns-absolute"
            data-nosto-element="autocomplete"
        >
            <div class="ns-autocomplete-inner ns-w-100 ns-lg-flex ns-lg-nowrap">
                <div class="ns-keywords-section">
                    {keywords?.hits?.length > 0 && (
                        <>
                            <h3 class="ns-section-heading">
                                Suggestions
                            </h3>
                            <div class="ns-keywords-list ns-flex ns-flex-wrap ns-lg-flex-col">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                        </>
                    )}
                </div>
                <div class="ns-products-section">
                    {products?.hits?.length > 0 && (
                        <div>
                            <h3 class="ns-section-heading">
                                Products
                            </h3>
                            <div class="ns-product-list ns-lg-grid">
                                {products?.hits?.map(hit => (
                                    <AutocompleteElement key={hit.productId} hit={hit} class="ns-block">
                                        <div
                                            class="ns-product-inner ns-flex ns-lg-block"
                                            data-url={hit.url}
                                            data-nosto-element="product"
                                        >
                                            <div class="ns-product-image-wrap ns-relative ns-w-100">
                                                <img
                                                    class="ns-product-image ns-block ns-w-100 ns-h-100"
                                                    src={hit.imageUrl.replace('.jpg', '_520x.jpg').replace('.png', '_520x.png').replace('.webp', '_520x.webp') ?? productImagePlaceholder}
                                                    alt={hit.name}
                                                    width="320"
                                                    height="500"
                                                    loading="lazy"
                                                    fetchPriority="low"
                                                />
                                            </div>
                                            <div class="ns-product-details ns-flex ns-flex-col">
                                                <div class="ns-product-title">
                                                    {hit.name}
                                                </div>
                                                <div class="ns-product-price-wrap ns-flex ns-flex-nowrap">
                                                    {hit.listPrice && hit.listPrice > hit.price && (
                                                        <>
                                                            <span class="sr-only visually-hidden">Regular Price:</span>
                                                            <span class="ns-product-list-price">{format(hit.listPrice)}</span>
                                                        </>
                                                    )}
                                                    <span class="sr-only visually-hidden">Final Price:</span>
                                                    <span class="ns-product-price">{format(hit.price)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </AutocompleteElement>
                                ))}
                            </div>
                            <SubmitButton 
                                text={`See ${response?.products?.total} results for "${response?.query}"`}
                                className="ns-relative ns-inline-block"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter}>
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
